import { type Dictionary } from '@bbk/contracts/type-utils';

export const toDictionary = <T extends { id: string | number }>(
  collection: T[]
): Dictionary<T> => Object.fromEntries(collection.map((el) => [el.id, el]));
